import { RCCallout, RCButtonLink } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import React from 'react';
import I18n from 'i18n-js';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { InfoIcon } from '@reverbdotcom/cadence/icons/react';

export function InternationalTaxProfileBanner() {
  return (
    <RCCallout
      themeType="utility"
      variant="info-ultralight"
      icon={<InfoIcon />}
      title={I18n.t('discovery.internationalTaxProfile.banner.bannerTitle')}
      cta={(
        <RCButtonLink
          variant="filled"
          renderLink={c => <CoreLink to="/my/selling/international_tax_profile">{c}</CoreLink>}
        >
          <Translate text="discovery.internationalTaxProfile.banner.bannerCta" />
        </RCButtonLink>
      )}
    >
      <Translate tag="p" text="discovery.internationalTaxProfile.banner.bannerContent" />
    </RCCallout>
  );
}

export default InternationalTaxProfileBanner;
